import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticleSummaries from './components/ArticleSummaries';
import CTABanner from './components/CTABanner';
import TrustSection from './components/TrustSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://itaobuyspread.top/#website',
      name: 'Itaobuy Spreadsheet Italia',
      url: 'https://itaobuyspread.top',
      description: 'Guida completa a Itaobuy Spreadsheet per trovare i migliori prodotti di moda, scarpe, sneakers e accessori in Italia. Database aggiornato con foto QC e recensioni verificate.',
      inLanguage: 'it',
      publisher: {
        '@type': 'Organization',
        '@id': 'https://itaobuyspread.top/#organization',
        name: 'Itaobuy Team',
        url: 'https://itaobuyspread.top',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
        },
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://itaobuyspread.top/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://itaobuyspread.top/#webpage',
      url: 'https://itaobuyspread.top',
      name: 'Itaobuy Spreadsheet Italia | Guida Completa ai Migliori Prodotti 2026',
      description: 'Itaobuy Spreadsheet Italia: la guida definitiva per trovare i migliori prodotti di moda, scarpe, sneakers e accessori. Scopri come risparmiare con lo spreadsheet aggiornato, sicuro e facile da usare per lo shopping online internazionale nel 2026.',
      inLanguage: 'it',
      isPartOf: { '@id': 'https://itaobuyspread.top/#website' },
      about: { '@id': 'https://itaobuyspread.top/#organization' },
      datePublished: '2026-07-14',
      dateModified: '2026-07-14',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://itaobuyspread.top',
          },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleSummaries />
        <CTABanner />
        <TrustSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
    </>
  );
}